export function getKartice(kartice) {
    return { type: 'GET_KARTICE', kartice };
}
